import { getIframesToken, IS_IFRAMES } from "./MortgageGPT/constants";

export async function request<T = any>(
  url: string,
  params?: Omit<Parameters<typeof fetch>[1], "body"> & {
    body?: any;
    /**
     * @name isSuccess 判断是否 resolve
     * @param res The Response interface of the Fetch API represents the response to a request.
     * @description 返回true拿到 resolve json，否则返回 reject
     */
    isSuccess?(res: Response): boolean | Promise<boolean>;
  },
) {
  const Authorization = `Bearer ${
    IS_IFRAMES
      ? localStorage.getItem(getIframesToken())
      : sessionStorage.getItem("ZeitroA")
  }`;
  const res = await fetch(url, {
    method: "GET", // 不传默认都走GET
    ...params,
    headers: { Authorization, ...(params?.headers || {}) },
    body: params?.body ? JSON.stringify(params.body) : undefined,
  });
  if (params?.isSuccess) {
    // isSuccess 是自定义校验逻辑，因为有些接口并没有返回json，导致 “res.json()” 序列化失败
    const success = await params.isSuccess(res);
    return success ? Promise.resolve(res) : Promise.reject(res);
  }
  const data = await res.json();
  return Promise.resolve<T>(data);
}
